import React, { useState } from "react";
import axios from "axios";
import style from "../Contact_Us/Contactus.module.css";
import { API_BASE_URL, contactus_api } from "../../../Apiconfig";

const ContactUs = () => {
    const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Replace the URL with your backend API endpoint
      const response = await axios.post(
        `${contactus_api}contact_us_Querie.php`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Check the response from the backend
      if (response.data.success) {
        // alert(response.data.message);
        setSuccessMessage("Message Sand Successfully!");  // Set the success message
        setTimeout(() => setSuccessMessage(""), 1000);
        setFormData({ name: "", email: "", message: "" }); // Reset the form
      } else {
        alert(response.data.message); // Error message from the backend
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      alert("Failed to submit the form. Please try again later.");
    }
  };

  return (
    <div className={`container ${style.servicesSection} mb-4`} id="Contact_Us">
      <div >
        <div className="row d-flex align-items-center">
          <div className={`col-12 ${style.customCol}`}>
            <h1 className={style.title}>
              <i className={`fa fa-phone ${style.icontitle} mb-4`} /> Contact Us
            </h1>
          </div>
        </div>

        <div className={`row ${style.therow}`}>
          <div className={`${style.rightsidecol} col-lg-6`}>
            <div className={style.contactDetails}>
              <div className={style.detailItem}>
                <span className={style.icon}>
                  <i className="fa-solid fa-phone"></i>
                </span>
                <span className={style.text}>Phone: 8085*****1</span>
              </div>
              <div className={style.detailItem}>
                <span className={style.icon}>
                  <i className="fa-solid fa-envelope"></i>
                </span>
                <span className={style.text}>Email: shope****@gmail.com</span>
              </div>
              <div className={style.detailItem}>
                <span className={style.icon}>
                  <i className="fa-solid fa-location-dot"></i>
                </span>
                <span className={style.text}>
                  Address: Dur** Nag** Vid****
                </span>
              </div>
              <div className={style.detailItem}>
                <span className={style.icon}>
                  <i className="fa-solid fa-clock"></i>
                </span>
                <span className={style.text}>
                  Business Hours: Mon-Sat, 8:00 AM - 8:00 PM
                </span>
              </div>
            </div>

            <div className={style.alternativeContainer}>
              <h6 className={style.subheading}>Visit Us at Our Location</h6>
              <div className={style.mapContainer}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=YOUR_GOOGLE_MAPS_EMBED_URL"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>

          <div className={`${style.rightsidecol} col-lg-6`}>
            <form
              className={`${style.contactForm}`}
              onSubmit={handleSubmit}
            >
              <div className="row">
                <div className={style.formGroup}>
                  <label htmlFor="name" className={style.label}>
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className={style.input}
                  />
                </div>

                <div className={style.formGroup}>
                  <label htmlFor="email" className={style.label}>
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className={style.input}
                  />
                </div>

                <div className={style.formGroup}>
                  <label htmlFor="message" className={style.label}>
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Write your message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    className={style.textarea}
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className={`btn btn-primary ${style.submitButton}`}
                >
                  <i className="fas fa-paper-plane"></i> Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
                        {/* Success message */}
{successMessage && (
  <div className={style.successMessage}>
    {successMessage}
  </div>
)}
    </div>
  );
};

export default ContactUs;
